import { NgClass } from '@angular/common';
import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { AppModulesType } from '../../../../_shared/enums/appModulesType.enum';
import { StorageService } from '../../../../_shared/services';
import { ActiveModulesService } from '../../../../_shared/services/activeModules.service';
import { CallStateEnum } from '../call-state.enum';
import { TelemedicineService } from '../telemedicine.service';
import { VideoComponent } from '../video/video.component';

@Component({
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'telemedicine',
    templateUrl: './telemedicine.component.html',
    styleUrls: ['./telemedicine.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgClass, VideoComponent],
})
export class TelemedicineComponent implements OnInit {
    private telemedService = inject(TelemedicineService);
    private am = inject(ActiveModulesService);
    private storage = inject(StorageService);

    public callState: CallStateEnum = CallStateEnum.NONE;
    public callStates = CallStateEnum;
    public windowSize = 'modal';
    public windowPosition = 'bottom-right';
    public isTelemedicineModuleActive = false;
    public termData;

    ngOnInit() {
        this.termData = this.storage.getSelectedTerm();
        this.isTelemedicineModuleActive = this.am.isAM(AppModulesType.TELEMEDICINE);
        this.am.getAMOnChange().subscribe(() => {
            this.isTelemedicineModuleActive = this.am.isAM(AppModulesType.TELEMEDICINE);
        });

        this.telemedService.getCallState().subscribe(callState => {
            this.callState = callState;
        });

        this.telemedService.getWindowSize().subscribe(size => {
            this.windowSize = size;
        });

        this.telemedService.getWindowPosition().subscribe((position: string) => {
            this.windowPosition = position;
        });
    }
}
